/**
 * @file A loader for the Paddle and Ball mini-game
 * @author Gonzalo Alvarez de Aldecoa <gon@galdecoa.com>
 * @license GPL-3.0-or-later
 * @version 2310.01.001
 */

/** @module minigameloader */

import { PaddleAndBallGame } from "./PaddleAndBallGame.js";

class MiniGameLoader {

	/**
	 * A container for the mini-game structure
	 * @type {HTMLElement?}
	 */
	#container = null;

	#gameDialog = null;

	#controlsDialog = null;
	
	#paddleAndBallGame = null;
	
	#paddleAndBallGameIsPaused = true;

	#game = null;

	#gameInteractivesModal = null;

	#showPaddleAndBallGame( mixedEvent ) {
		mixedEvent && mixedEvent.preventDefault && mixedEvent.preventDefault();
		this.#gameInteractivesModal.keepGamePausedOnClose = true;
		this.#gameInteractivesModal.close();
		this.#gameDialog.show();
		this.#paddleAndBallGame = new PaddleAndBallGame( 
			this.#gameDialog.querySelector( "canvas" ) 
		);
		this.#paddleAndBallGameIsPaused = this.#paddleAndBallGame.isPlaying;
	}

	#onLauncherClick = function( clickEvent ) {}

	bindPaddleAndBallGameLaunchers( container = document ) {
		const launchersSelector = "a.launch-paddleandballgame";
		const launchers = container.querySelectorAll( launchersSelector );
		for( let l = launchers.length - 1; l >= 0; l = l - 1 ) {
			const launcher = launchers[ l ];
			launcher.removeEventListener( "click", this.#onLauncherClick );
			launcher.addEventListener( "click", this.#onLauncherClick );
		}
	}

	#onAnchorClick( clickEvent ) {
		clickEvent.preventDefault && clickEvent.preventDefault();
		this.#controlsDialog.showModal();
		this.#paddleAndBallGameIsPaused = this.#paddleAndBallGame.isPaused;
		this.#paddleAndBallGame.isPaused = true;
	}

	#onGameDialogClose( closeEvent ) { 
		if ( document.documentElement.classList.contains( "game-mode" ) ) {
			this.#game.pause( false );
			this.#gameInteractivesModal.keepGamePausedOnClose = false;
		}
		this.#paddleAndBallGame.dispose();
		this.#paddleAndBallGame = null;
	}

	#onControlsDialogClose( closeEvent ) {
		this.#paddleAndBallGame.isPaused = this.#paddleAndBallGameIsPaused;
	}

	#addEventListeners() {
		const onAnchorClick = this.#onAnchorClick.bind( this );
		const anchor = this.#container.querySelector( "a" );
		anchor.addEventListener( "click", onAnchorClick );
		const onGameDialogClose = this.#onGameDialogClose.bind( this );
		this.#gameDialog.addEventListener( "close", onGameDialogClose );
		const onControlsDialogClose = this.#onControlsDialogClose.bind( this );
		this.#controlsDialog.addEventListener( "close", onControlsDialogClose );
	}

	constructor( game, container, gameInteractivesModal ) {

		this.#game = game;

		this.#container = container;
		this.#gameDialog = this.#container.querySelector( 
			"dialog.paddleandballgame" 
		);
		this.#controlsDialog = this.#container.querySelector( "dialog.controls" );

		this.#gameInteractivesModal = gameInteractivesModal;

		this.#onLauncherClick = this.#showPaddleAndBallGame.bind( this );

		this.#addEventListeners();
		this.bindPaddleAndBallGameLaunchers();

	}

}

export { MiniGameLoader };